var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPauseCircle = function SvgPauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M7.98 1.334A6.67 6.67 0 0 0 1.313 8a6.67 6.67 0 0 0 6.667 6.667A6.67 6.67 0 0 0 14.647 8c0-3.68-2.98-6.666-6.667-6.666m-.833 8.686c0 .32-.134.447-.474.447h-.866c-.34 0-.474-.127-.474-.447V5.98c0-.32.134-.447.474-.447h.86c.34 0 .473.127.473.447v4.04zm3.52 0c0 .32-.134.447-.474.447h-.86c-.34 0-.473-.127-.473-.447V5.98c0-.32.133-.447.473-.447h.86c.34 0 .474.127.474.447z"
  })));
};
export default SvgPauseCircle;